import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
const API_URL = process.env.REACT_APP_API_URL;

  // اگر قبلاً لاگین شده بود، مستقیم بفرست به داشبورد
  useEffect(() => {
    if (localStorage.getItem('admin_token')) {
      navigate('/admin/dashboard');
    }
  }, []);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const handleSendOtp = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`https://api.mogym.ir/api/admin/send-otp/${phone}`, {
        method: 'POST',
      });

      if (res.ok) {
        setOtpSent(true);
        setCountdown(120);
      } else {
        const data = await res.json();
        setError(data.Message || 'خطا در ارسال کد');
      }
    } catch {
      setError('خطا در ارتباط با سرور');
    }
    setLoading(false);
  };

  const handleVerifyOtp = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch('https://api.mogym.ir/api/admin/login/otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phoneNumber: phone, otpCode: otp }),
      });

      const data = await res.json();

      if (res.ok && data.Jwt) {
        localStorage.setItem('admin_token', data.Jwt);
        navigate('/admin/dashboard');
      } else {
        setError(data.Message || 'کد تأیید نادرست است');
      }
    } catch {
      setError('خطا در ارتباط با سرور');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-[#0e1015] text-black dark:text-white px-4">
      <div className="bg-white dark:bg-[#1a1d2e] p-6 rounded-xl shadow max-w-md w-full">
        <h1 className="text-xl font-bold text-center mb-6">ورود مدیر سیستم</h1>

        {!otpSent && (
          <input
            type="tel"
            placeholder="شماره موبایل ادمین"
            value={phone}
            maxLength={11}
            onChange={(e) => setPhone(e.target.value)}
            className="w-full p-3 mb-4 rounded-xl border dark:border-gray-600 bg-white dark:bg-[#2a2f3b]"
          />
        )}

        {otpSent && (
          <>
            <input
              type="text"
              placeholder="کد تایید"
              value={otp}
              maxLength={6}
              onChange={(e) => setOtp(e.target.value)}
              className="w-full p-3 mb-4 rounded-xl border dark:border-gray-600 bg-white dark:bg-[#2a2f3b]"
            />
            {countdown > 0 ? (
              <p className="text-sm text-gray-500 mb-4 text-center">
                ارسال مجدد کد تا {countdown} ثانیه دیگر
              </p>
            ) : (
              <button onClick={handleSendOtp} className="text-blue-500 text-sm mb-4 underline">
                ارسال مجدد کد
              </button>
            )}
          </>
        )}

        {error && <p className="text-red-500 text-sm mb-3 text-center">{error}</p>}

        <button
          onClick={otpSent ? handleVerifyOtp : handleSendOtp}
          disabled={loading || (otpSent ? !otp : !phone)}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-xl disabled:opacity-50"
        >
          {loading ? 'در حال ارسال...' : otpSent ? 'ورود' : 'ارسال کد'}
        </button>
      </div>
    </div>
  );
}
